// Modules
import React from 'react'
import { Spinner } from '@blueprintjs/core'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from "hooks/system/useLanguage"

// Helpers
import { convertFontSizeToPixelSize } from 'helpers/size'

// Styles
import './Section.scss'

// Component: Layout > Page > Section
function Section ({ children, className, controls, hasBottomLine, hasBottomSpacing, hasTopLine, hasTopSpacing, isFixed, isIncapacious, isLoading, isPushed, name, style, subtitle, title, willCenter, willGrow }) {
	// Data
	// const { translate } = useLanguage('components.layout.page.components.section')

	// Functions
	function renderTitle () {
		if (!title) return null
		return typeof title === 'string'
			? <h3 className="aix-title">
				{isLoading &&
					<Spinner
						className="aix-title-loader"
						size={convertFontSizeToPixelSize('.75rem')} />
				}
				{title}
			</h3>
			: title
	}
	function renderSubtitle () {
		if (!subtitle) return null
		return typeof subtitle === 'string'
			? <p className="aix-subtitle">{subtitle}</p>
			: subtitle
	}
	function renderContent () {
		if (!children) return null
		return React.Children.map(children, (child, index) => {
			if (!child) return null
			return (
				<div
					key={index}
					className="aix-section-content">
					{child}
				</div>
			)
		})
	}

	// Render
	return (
		<section
			data-section={name}
			data-component="section"
			className={
				'aix-section' +
				(isFixed ? ' aix-sticky' : '') +
				(isPushed ? ' aix-pushed' : '') +
				(isLoading ? ' aix-loading' : '') +
				(isIncapacious ? ' aix-incapacious' : '') +
				(willCenter ? ' aix-center' : '') +
				(willGrow ? ' aix-grow' : '') +
				(hasTopLine ? ' aix-top-line' : '') +
				(hasTopSpacing ? ' aix-top-spacing' : '') +
				(hasBottomLine ? ' aix-bottom-line' : '') +
				(hasBottomSpacing ? ' aix-bottom-spacing' : '') +
				(className ? ` ${className}` : '')
			}
			style={style}>
			{(title || subtitle || controls) &&
				<div className="aix-section-header">
					{(title || subtitle) &&
						<div className="aix-section-information">
							{renderTitle()}
							{renderSubtitle()}
						</div>
					}
					{controls && <div className="aix-controls aix-section-controls">{controls}</div>}
				</div>
			}
			{renderContent()}
		</section>
	)
}

// Properties
Section.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	controls: PropTypes.node,
	hasBottomLine: PropTypes.bool,
	hasBottomSpacing: PropTypes.bool,
	hasTopLine: PropTypes.bool,
	hasTopSpacing: PropTypes.bool,
	isFixed: PropTypes.bool,
	isIncapacious: PropTypes.bool,
	isLoading: PropTypes.bool,
	isPushed: PropTypes.bool,
	name: PropTypes.string.isRequired,
	style: PropTypes.object,
	subtitle: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.number,
		PropTypes.string
	]),
	title: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.number,
		PropTypes.string
	]),
	willCenter: PropTypes.bool,
	willGrow: PropTypes.bool
}
Section.defaultProps = {
	hasBottomLine: false,
	hasBottomSpacing: true,
	hasTopLine: false,
	hasTopSpacing: true,
	isFixed: false,
	isIncapacious: false,
	isLoading: false,
	willCenter: false,
	willGrow: false
}

// Export
export default Section
